import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';


class Tooltip extends Component {
  componentDidMount() {
    const { container, fixed } = this.props;
    if (typeof document === typeof undefined) return;
    this.container = container || document.body;
    this.componentEl = ReactDOM.findDOMNode(this); // eslint-disable-line
    this.tooltipEl = document.createElement('div');

    this.componentEl.addEventListener(fixed ? 'mouseenter' : 'mousemove', this.handleMouseMove.bind(this));
    this.componentEl.addEventListener('mouseleave', this.handleMouseOut.bind(this));
    this.componentEl.addEventListener('click', this.handleOnClick.bind(this));

  }

  componentWillUnmount() {
    const { fixed } = this.props;
    this.componentEl.removeEventListener(fixed ? 'mouseenter' : 'mousemove', this.handleMouseMove.bind(this));
    this.componentEl.removeEventListener('mouseleave', this.handleMouseOut.bind(this));
  }

  getTooltipPosition(e) {
    const { fixed, position, tooltipX, tooltipY } = this.props;
    let pointX;
    let pointY;
    const bodyRect = document.body.getBoundingClientRect();
    const containerRect = this.container.getBoundingClientRect();
    const containerOffsetX = containerRect.left - bodyRect.left;
    const containerOffsetY = containerRect.top - bodyRect.top;
    if (fixed) {
      const componentRect = this.componentEl.getBoundingClientRect();
      const componentOffsetX = componentRect.left - containerOffsetX;
      const componentOffsetY = componentRect.top - containerOffsetY;
      const componentWidth = this.componentEl.offsetWidth;
      const componentHeight = this.componentEl.offsetHeight;
      let cOffsetX = 0;
      let cOffsetY = 0;
      switch (position) {
        case 'top':
          cOffsetX = componentWidth / 2 * (tooltipX / 100);
          cOffsetY = 0;
          break;
        case 'right':
          cOffsetX = componentWidth;
          cOffsetY = componentHeight / 2 * (tooltipY / 100);
          break;
        case 'bottom':
          cOffsetX = componentWidth * (tooltipX / 100);
          cOffsetY = componentHeight * (tooltipY / 100);
          break;
        case 'left':
          cOffsetX = 0;
          cOffsetY = componentHeight / 2 * (tooltipY / 100);
          break;
        default:
          return null;
      }
      pointX = componentOffsetX + cOffsetX + (window.scrollX || window.pageXOffset);
      pointY = componentOffsetY + cOffsetY + (window.scrollY || window.pageYOffset);
    } else {
      const { clientX, clientY } = e;
      pointX = clientX - containerOffsetX + (window.scrollX || window.pageXOffset);
      pointY = clientY - containerOffsetY + (window.scrollY || window.pageYOffset);
    }
    return {
      x: pointX,
      y: pointY,
    };
  }

  getTooltipOffset() {
    const { position, space } = this.props;
    const tooltipW = this.tooltipEl.offsetWidth;
    const tooltipH = this.tooltipEl.offsetHeight;
    let offsetX = 0;
    let offsetY = 0;
    switch (position) {
      case 'top':
        offsetX = -(tooltipW / 2);
        offsetY = -(tooltipH + Number(space));
        break;
      case 'right':
        offsetX = Number(space);
        offsetY = -(tooltipH / 2);
        break;
      case 'bottom':
        offsetX = -(tooltipW / 2);
        offsetY = Number(space);
        break;
      case 'left':
        offsetX = -(tooltipW + Number(space));
        offsetY = -(tooltipH / 2);
        break;
      default:
        return null;
    }
    return {
      x: offsetX,
      y: offsetY,
    };
  }

  resetTooltip() {
    if (this.tooltipEl.childNodes[0] !== undefined) {
      this.tooltipEl.removeChild(this.tooltipEl.childNodes[0]);
      this.tooltipEl.removeChild(this.tooltipEl.childNodes[0]);
      this.container.removeChild(this.tooltipEl);
      this.serpContainer.removeEventListener('scroll', this.scrollHandlerBind, true);
    }
  }

  handleMouseMove(e) {
    const { title, baseClassName, showingTooltip, position } = this.props;
    if (title === '') return;

    this.serpContainer = window;
    this.scrollHandler = () => {
      this.resetTooltip();
    };
    this.scrollHandlerBind = this.scrollHandler.bind(this);
    this.serpContainer.addEventListener('scroll', this.scrollHandlerBind, true);

    const tooltipArrowEl = document.createElement('div');
    tooltipArrowEl.className = 'tooltip-arrow';
    const tooltipContentEl = document.createElement('div');
    tooltipContentEl.className = 'tooltip-inner';
    tooltipContentEl.textContent = title;
    this.tooltipEl.appendChild(tooltipArrowEl);
    this.tooltipEl.appendChild(tooltipContentEl);
    this.tooltipEl.className = `${baseClassName} tooltip-${showingTooltip ? `${position}` : 'not-showing-tooltip'}`;
    this.container.appendChild(this.tooltipEl);
    const tooltipPosition = this.getTooltipPosition(e);
    const tooltipOffset = this.getTooltipOffset();

    this.tooltipEl.style.transition = 'opacity 0.25s';
    this.tooltipEl.style.transition = 'transform 0.25s';
    this.tooltipEl.style.transitionTimingFunction = 'cubic-bezier(0.42, 0, 0, 1.38)';
    this.tooltipEl.style.left = `${tooltipPosition.x + tooltipOffset.x}px`;
    this.tooltipEl.style.top = `${tooltipPosition.y + tooltipOffset.y}px`;
    this.tooltipEl.style.opacity = 1;
    this.tooltipEl.style.transform = 'scale(1, 1)';
  }

  handleMouseOut() {
    this.resetTooltip();
  }

  handleOnClick() {
    this.resetTooltip();
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

Tooltip.defaultProps = {
  baseClassName: '',
  container: (typeof document === typeof undefined) ? null : document.body,
  fixed: true,
  position: 'top',
  showingTooltip: true,
  space: 5,
  title: '',
  tooltipX: 50,
  tooltipY: 100,
};

Tooltip.propTypes = {
  baseClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  container: PropTypes.shape(),
  fixed: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),
  showingTooltip: PropTypes.bool,
  space: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  tooltipX: PropTypes.number,
  tooltipY: PropTypes.number,
};

export default Tooltip;
